// extracted by mini-css-extract-plugin
export default {"message":"saveSuccess_message__vbeTu"};